"use strict";

define('view/text.editor',['uikit/elements/input', 'underscore', 'backbone', 'redactor', 'FileAPI', '../model/docstore', '../model/upload', '../templates', 'backbone.radio'], function (Input, _, Backbone, Redactor, FileAPI, DocStore, UploadModel, Templates, Radio) {
  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  }
  var channel = Radio.channel('global');
  var REDACTOR_EVENTS = ['init', 'change', 'blur', 'keydown', 'keyup', 'enter', 'keyup', 'autosave', 'execCommand', 'pasteBefore', 'pasteAfter', 'imageUpload', 'imageUploadError', 'imageDelete', 'fileUpload', 'fileUploadError', 'syncBefore', 'syncAfter'];
  if (typeof window.RedactorPlugins === 'undefined') {
    window.RedactorPlugins = {};
  }
  window.RedactorPlugins.statusMessage = {
    init: function init() {
      var component = this.opts._component,
        div = $(document.createElement('div'));
      div.addClass('status text').css({
        display: 'inline-block',
        position: 'absolute',
        right: '1em',
        top: 0,
        color: '#888',
        fontSize: '11px',
        lineHeight: '32px'
      });
      component.on('change:message', function () {
        div.text(component.message);
      }).on('change:loading', function () {
        div.toggleClass('loading', component.loading);
        if (component.loading && !component.text) {
          div.text('Loading');
        } else if (!component.loading && !component.text) {
          div.text('');
        }
      });
      div.toggleClass('loading', component.loading);
      div.text(component.message);
      this.$toolbar.append(div);
    }
  };
  window.RedactorPlugins.fullScreen = {
    init: function init() {
      var component = this.opts._component;
      this.fullscreen = false;
      this.buttonAdd('fullscreen', 'Full Screen', this.toggleFullScreenMode);
      component.on('before:destroy', this.exitFullScreenMode, this);
    },
    toggleFullScreenMode: function toggleFullScreenMode() {
      if (this.fullscreen) {
        this.exitFullScreenMode();
      } else {
        this.enterFullScreenMode();
      }
    },
    enterFullScreenMode: function enterFullScreenMode() {
      if (this.fullscreen) {
        return;
      }
      this.fullscreen = true;
      this.buttonActive('fullscreen');
      var div = this._fullScreenDiv = $('<div/>').addClass('redactor_fullscreen').css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: '#fff',
        overflow: 'hidden',
        zIndex: 1002
      }).appendTo(this.opts.fullScreenContainer || 'body').append(this.$toolbar).append(this.$editor);
      this.$editor.css({
        borderBottom: '0',
        overflow: 'auto',
        height: 'calc(100% - 32px)'
      });
    },
    exitFullScreenMode: function exitFullScreenMode() {
      if (!this.fullscreen) {
        return;
      }
      this.fullscreen = false;
      this.buttonInactive('fullscreen');
      if (this._fullScreenDiv) {
        this.$editor.css({
          borderBottom: '',
          overflow: '',
          height: ''
        });
        this.$box.prepend(this.$editor).prepend(this.$toolbar);
        this._fullScreenDiv.remove();
        this._fullScreenDiv = null;
      }
    }
  };
  window.RedactorPlugins.imageEmbed = {
    init: function init() {
      var component = this.opts._component;
      var _filesAdded = _.debounce(this.filesAdded);
      this.filesToUpload = [];
      this.buttonAdd('image', 'Insert Image', function () {
        this.selectionSave();
        var modal = channel.request('image:chooser', {
          accept: ['.png', '.jpg']
        });
        modal.on('image:file', function (file) {
          this.filesToUpload.push(file);
        }, this).on('image:link', function (link) {
          this.insertImageUrl(link);
        }, this).on('modal:hidden', function () {
          if (this.filesToUpload.length > 0) {
            _filesAdded.call(this);
          }
        }, this);
      });
      if (component) {
        component.on('before:destroy', this.destroy, this);
      }
    },
    pasteClipboardUpload: function pasteClipboardUpload(e) {
      var self = this;
      this._addDataUrlToUploads(e.target.result);
      if (this.filesToUpload.length == 0) {
        return;
      }
      _.defer(function () {
        self.filesAdded();
      });
    },
    _addDataUrlToUploads: function _addDataUrlToUploads(url) {
      var arr = url.split(","),
        contentType = arr[0].split(";")[0].split(":")[1],
        data = arr[1],
        blob = null;
      if (String(contentType).toLowerCase().indexOf('image') == -1) {
        return false;
      }
      blob = b64toBlob(data, contentType);
      blob.name = 'filename';
      this.filesToUpload.push(blob);
      return blob;
    },
    pasteClipboardUploadMozilla: function pasteClipboardUploadMozilla() {
      var imageTag = 'data-mozilla-paste-image',
        imgs = this.$editor.find('img[' + imageTag + ']'),
        self = this;
      function replaceInsertImageSrc(uploads, docstores) {
        var index = 0;
        _.each(imgs, function (img, i) {
          if (!img.src) {
            return;
          }
          var docstore = docstores.at(index++);
          imgs.eq(i).attr('src', docstore.get('url')).removeAttr(imageTag);
          self.sync();
        });
      }
      _.each(imgs, function (img, i) {
        if (!img.src) {
          return;
        }
        this._addDataUrlToUploads(img.src);
      }, this);
      if (this.filesToUpload.length == 0) {
        return;
      }
      _.defer(function () {
        self.filesAdded({
          insert: false,
          callback: replaceInsertImageSrc
        });
      });
    },
    filesAdded: function filesAdded(options) {
      options = _.extend({
        insert: true
      }, options);
      var self = this;
      var UploadFileModel = this.opts.uploadFileModel || DocStore,
        uploadImageUrl = this.opts.uploadImageUrl || UploadFileModel.IMAGE_UPLOAD_URL;
      var uploads = UploadModel.createCollection(uploadImageUrl, this.filesToUpload, UploadFileModel).once('upload:complete', function (models, docstores) {
        if (options.callback) {
          options.callback(models, docstores);
        }
        if (options.insert) {
          docstores.each(function (docstore) {
            self.insertImageUrl(docstore.get('url'));
          });
        }
      });
      channel.request('file:upload', uploads);
      this.filesToUpload = [];
    },
    buildEventPaste: function buildEventPaste(e) {
      var oldsafari = false;
      if (this.browser('webkit') && navigator.userAgent.indexOf('Chrome') === -1) {
        var arr = this.browser('version').split('.');
        if (arr[0] < 536) oldsafari = true;
      }
      if (oldsafari) return true;
      if (this.browser('opera')) return true;
      if (!this.browser('mozilla') && this.opts.clipboardUpload && this.buildEventClipboardUpload(e)) return true;
      if (this.opts.cleanup) {
        this.rtePaste = true;
        this.selectionSave();
        if (!this.selectall) {
          if (this.opts.autoresize === true && this.fullscreen !== true) {
            this.$editor.height(this.$editor.height());
            this.saveScroll = this.document.body.scrollTop;
          } else {
            this.saveScroll = this.$editor.scrollTop();
          }
        }
        var frag = this.extractContent();
        setTimeout($.proxy(function () {
          var pastedFrag = this.extractContent();
          this.$editor.append(frag);
          this.selectionRestore();
          var html = this.getFragmentHtml(pastedFrag);
          this.pasteClean(html);
          if (this.opts.autoresize === true && this.fullscreen !== true) this.$editor.css('height', 'auto');
        }, this), 1);
      }
    },
    insertImageUrl: function insertImageUrl(url) {
      this.imageInsert({
        filelink: url
      });
    },
    destroy: function destroy() {}
  };
  window.RedactorPlugins.fuzzyInsert = {
    init: function init() {
      var component = this.opts._component,
        keyupCallback = this.opts.keyupCallback,
        self = this;
      if (!(this.opts.fuzzyModel instanceof Backbone.Model)) {
        this.opts.fuzzyModel = new Backbone.Model();
      }
      if (!(this.opts.fuzzyResults instanceof Backbone.Collection)) {
        this.opts.fuzzyResults = new Backbone.Collection();
      }
      component.on('before:destroy', this.destroy, this);
      this.opts.keyupCallback = function (e) {
        self._keyupEvent(e);
        if (keyupCallback) {
          keyupCallback.apply(this, arguments);
        }
      };
    },
    _keyupEvent: function _keyupEvent(e) {
      var keyCode = e.which;
      if (this.opts.fuzzyKeyCode === keyCode) {
        this._startFuzzySearch();
      }
    },
    _startFuzzySearch: function _startFuzzySearch() {
      var node = this.insertNode(document.createElement('p'));
      $(node).text('').on('keypress', function () {
        console.log(this.text());
      });
      this.setCaret(node, 0);
    },
    destroy: function destroy() {}
  };
  window.RedactorPlugins.imageLoading = {
    init: function init() {
      var component = this.opts._component;
      if (component) {
        window._test = component;
        component.on('redactor:change', this._redactorDidChange, this);
      }
    },
    _redactorDidChange: function _redactorDidChange() {
      var component = this.opts._component,
        $imgs = this.$editor.find('img'),
        needsLoading = 0;
      function done() {
        component.loading = false;
      }
      ;
      _.each($imgs, function (img, index) {
        var $img = $imgs.eq(index);
        if (img.naturalWidth) {
          $img.data('imageLoaded', true);
          return;
        }
        if ($img.data('imageLoaded')) {
          return;
        }
        needsLoading++;
        $img.one('load', function () {
          $img.data('imageLoaded', true);
          done();
        }).one('error', function () {
          $img.data('imageLoaded', true);
          done();
        });
      });
      if (needsLoading > 0) {
        component.loading = true;
        done = _.after(needsLoading, done);
      }
    }
  };
  var INCLUDED_PLUGINS = ['statusMessage', 'imageEmbed', 'fullScreen', 'imageLoading'];
  if (window.File && window.FileReader && window.FileList && window.Blob) {}
  var TextEditor = Input.extend({
    events: _.extend({}, Input.prototype.events, {
      'focus .redactor_editor': function focus_Redactor_editor() {
        this.$el.find('.redactor_toolbar').show();
      },
      'blur .redactor_editor': function blur_Redactor_editor() {
        if (this.getOption('focusOnlyToolbar')) {}
      }
    }),
    options: {
      value: null,
      message: '',
      loading: false,
      tabindex: 0,
      autosave: 3000,
      focusOnlyToolbar: false
    },
    template: false,
    initialize: function initialize() {
      Input.prototype.initialize.apply(this, arguments);
      var redactorOptions = _.omit(this.options, 'value', 'autosave', 'message'),
        self = this;
      _.each(REDACTOR_EVENTS, function (eventName) {
        redactorOptions[eventName + 'Callback'] = function (data) {
          self.triggerMethod.apply(self, ['redactor:' + eventName].concat(_.toArray(arguments)));
          return data;
        };
      });
      if (_.isArray(redactorOptions.plugins)) {
        redactorOptions.plugins.push.apply(redactorOptions.plugins, INCLUDED_PLUGINS);
      } else {
        redactorOptions.plugins = _.clone(INCLUDED_PLUGINS);
      }
      if (_.isArray(redactorOptions.ignorePlugins)) {
        redactorOptions.plugins = _.difference(redactorOptions.plugins, redactorOptions.ignorePlugins);
      }
      redactorOptions._component = this;
      this.redactor = Redactor(document.createElement('textarea'), redactorOptions);
    },
    _startEdit: function _startEdit() {
      var self = this;
      clearTimeout(this._autosaveTimeout);
      this.triggerMethod('edit:start');
      if (this.autosave) {
        this._autosaveTimeout = setTimeout(function () {
          self.triggerMethod('autosave');
          self.triggerMethod('edit:end');
        }, this.autosave);
      }
    },
    onFirstRender: function onFirstRender() {
      this.vent.on('change:value', _.debounce(this._updateValue, 1), this);
      this._updateValue();
      this.on('redactor:change', function () {
        if (this._ignoreChanges) {
          return;
        }
        var newValue = this.redactor.get(),
          changed = this.value !== newValue;
        this._internal.value = newValue;
        if (changed) {
          this._startEdit();
        }
      }, this);
      this.$el.append(this.redactor.$box);
    },
    _updateValue: function _updateValue() {
      this._ignoreChanges = true;
      this.redactor.set(this.value == null ? '' : String(this.value), false);
      this._ignoreChanges = false;
    }
  });
  return TextEditor;
});

